import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { EmailSettings, SettingsFrame } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useConfig } from '../../../contexts/config';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const EmailSettingsPage = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, currentProjectType, currentProject, error } =
    useCurrentProject(projectId);
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    if (!error) {
      xsollaAnalytics.sendOpen('login_pa_module__email_settings_open', projectId);
    }
  }, [error]);

  if (currentProjectFetching) {
    return <Preloader />;
  }

  if (error) {
    return <ToDashboardError error={error} pageName="email_settings_open" />;
  }

  if (currentProject) {
    return (
      <SettingsFrame projectId={projectId} projectType={currentProjectType}>
        <EmailSettings currentProjectType={currentProjectType} currentProject={currentProject} />
      </SettingsFrame>
    );
  }

  return <></>;
};

export default withRouter(EmailSettingsPage);
